import { FIREBASE_PROJECT_IDS, FIREBASE_WEB_APP_IDS } from "@repo/common";

const projectId = FIREBASE_PROJECT_IDS.PRODUCTION;

export const isProdServer = true;

export const firebaseConfig = {
  apiKey: "AIzaSyAuMhNXirrD_RbRtKnzpWu-Ek6WpLg2SHM",
  authDomain: `${projectId}.firebaseapp.com`,
  projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId: "295518221716",
  appId: FIREBASE_WEB_APP_IDS.PRODUCTION,
  measurementId: "G-J5774ZRRRV",
};
